import React, { useContext, useState } from 'react';
import { BeneficiaryContext } from '../contexts/BeneficiaryContext';

export default function CsvReader({ groupId }) {
  const { submit } = useContext(BeneficiaryContext);
  const [csvFile, setCsvFile] = useState();

  return (
    <form id="csv-form" encType={'multipart/forms-data'}>
      {!csvFile ? (
        <div className={'flex flex-row items-center'}>
          <label
            className={
              'bg-yellow-500 cursor-pointer px-4 py-2 rounded flex flex-row justify-center items-center'
            }
          >
            <i className={'fas fa-file-upload text-base mr-2'} />
            <span>import</span>
          </label>
          <input
            type="file"
            accept=".xlsx"
            className={'opacity-0 absolute'}
            onChange={(e) => {
              setCsvFile(e.target.files[0]);
            }}
          />
        </div>
      ) : csvFile ? (
        <button
          onClick={(e) => {
            e.preventDefault();
            if (csvFile) submit(groupId, csvFile);
            window.location.reload();
          }}
          className={'bg-yellow-500 cursor-pointer px-4 py-2 rounded'}
        >
          <i className={'far fa-save text-base mr-2'} />
          <span>Save</span>
        </button>
      ) : null}
    </form>
  );
}
